<template>
    <div class="detail-quantity dis-align">
        <p>发现<span>{{getQuantity(data.pageNumber)}}</span>个页面</p>
        <p>已处理<span>{{getQuantity(data.alreadyCount || data.pageNumber)}}</span></p>
        <p>待处理<span>{{getQuantity(data.notCount)}}</span></p>
    </div>
</template>

<script>
    import _ from 'lodash'
    export default {
        props: ['data'],
        data() {
            return {}
        },
        methods: {
            getQuantity(val) {
                return _.padStart(val, 5, '0');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail-quantity {
        $width: 29.6rem;
        position: absolute;
        right: 2.2rem;
        bottom: 8px;
        width: $width;
        height: 1.8rem;
        font-size: 0;
        text-align: center;
        background-color: #99a0ae;
        border-radius: $width/2 $width/2 0 0;
        p {
            display: inline-block;
            margin: 0;
            font-size: .9rem;
            color: #fff;
            padding: 0 16px;
            vertical-align: middle;
            span {
                margin: 0 6px;
            }
        }
        $bgArray: (#8adaff, #49fb87, #f8cb45);
        @each $item in $bgArray {
            $index: index($bgArray, $item);
            p:nth-child(#{$index}) {
                @if $index == 2 {
                    border: 1px solid #acb4c6;
                    border-width: 0 1px;
                }
                span {
                    color: $item;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// app/view/detail/DetailQuantity.vue